import React from "react";
import { useTranslation } from "react-i18next";
import wire from "assets/img/wire.png";

const Step1 = React.forwardRef((props, ref) => {
  const { t } = useTranslation('wizard');
  const isValidated = () => {
      return true;
  };
  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));
  return (
    <>
      <div className="info-text c-white">
        {t('storages.step2Body')}
      </div>
      <div className="text-center">
        <img src={wire} alt="wire-tool" />
      </div>
    </>
  );
});

export default Step1;
